import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { FormGroup } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';

import { Request } from './shared/request.model';
import { RequestService } from './shared/request.service';
import { ErnstWebService } from './ernstweb.service';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { ResponseService } from '../response/shared/response.service';
import { ClientTokenService } from '../clienttoken.service';
import { stateAbbreviationValidator } from '../location/shared/state-abbreviation.directive';
import { faCalculator } from '@fortawesome/free-solid-svg-icons/faCalculator';

@Component({
  selector: 'app-request',
  templateUrl: './request.component.html',
  styleUrls: ['./request.component.css']
})
export class RequestComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<Object> = new Subject();
  form: FormGroup;
  clientToken: string;
  faCalculator = faCalculator;

  constructor(
    private readonly fb: FormBuilder,
    private readonly requestService: RequestService,
    private readonly router: Router,
    private ernstWebservice: ErnstWebService,
    private responseService: ResponseService,
    private route: ActivatedRoute,
    private readonly clientTokenService: ClientTokenService
  ) {}

  ngOnInit(): void {
    this.clientToken = this.route.snapshot.paramMap.get('clientToken');
    this.clientTokenService.pushClientToken(this.clientToken);
    this.createForm();
    this.requestService.request$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((request: Request) => {
        if (request) {
          this.form.patchValue(request);
        }
      });
  }

  createForm() {
    this.form = this.fb.group({
      location: this.fb.group({
        streetAddress: [''],
        city: [''],
        state: ['Choose...', stateAbbreviationValidator],
        zip: ['', [Validators.required]]
      }),
      loan: this.fb.group({
        loanType: ['Sale'],
        closingDate: [new Date()],
        loanAmount: ['', [Validators.required]],
        purchasePrice: [''],
        mortgageType: ['Conventional'],
        rateType: ['Fixed']
      })
    });
  }

  onSubmit() {
    if (this.form.invalid) {
      return;
    }
    this.responseService.pushResponse(null);
    this.requestService.pushRequest(this.form.value);
    this.ernstWebservice.submit(this.form.value).subscribe(response => {
      this.responseService.pushResponse(response);
    });
    this.router.navigate(['/response', this.clientToken]);
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
